<template>
  <section>
    <div class="page">
      <div>
        <h2>Exiting groups</h2>
        <p>
          To exit a group:
        </p>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>
            Scroll down. Then tap <strong>Leave Group</strong> >
            <strong>OK</strong>.
          </li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
